// Máscara de WhatsApp enquanto digita. Padrão BR: +55 (11) 99999-8888.
// Começou com "+" e outro DDI → internacional, só dígitos depois do "+".
// O backend normaliza de novo (só dígitos + DDI, `User#whatsapp`); a máscara é
// só visual. Mesma regra do Cortex Gestão (app/frontend/lib/phone.js).
export const maskWhatsapp = value => {
  const raw = (value || '').trim();
  const intl = raw.startsWith('+');
  let d = raw.replace(/\D/g, '');

  if (intl && d.length <= 2 && '55'.startsWith(d)) return `+${d}`;
  if (intl && !d.startsWith('55')) return `+${d.slice(0, 15)}`;
  if (d.startsWith('55') && (intl || d.length > 11)) d = d.slice(2);

  d = d.slice(0, 11);
  if (!d) return '';
  if (d.length <= 2) return `+55 (${d}`;

  const num = d.slice(2);
  const split = num.length > 8 ? 5 : 4;
  const body =
    num.length > split ? `${num.slice(0, split)}-${num.slice(split)}` : num;
  return `+55 (${d.slice(0, 2)}) ${body}`;
};

// Valor salvo (só dígitos com DDI) → exibição. Vazio → ''.
export const formatWhatsapp = digits =>
  digits ? maskWhatsapp(`+${digits}`) : '';

// Mesma faixa do backend: 10 a 15 dígitos depois de tirar a máscara.
export const isValidWhatsapp = value => {
  const digits = (value || '').replace(/\D/g, '');
  return !digits || (digits.length >= 10 && digits.length <= 15);
};
